export default class AlTemplateGuestlistsController {

    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;
        this.translate = this.injector.get('$translate');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.api = this.injector.get('$http');
        this.angularState = this.injector.get('$state');
        this.alert = this.injector.get('Alert');

        this.templatesStore = null;
        this.rawTemplates = [];

        this._initWatchers();
    }

    // Public callable functions
    goToGuestlistDetails(row) {
        this.angularState.go('app.guestlists.rsvps.messages.templates', {gid: row.guestlist.id})
    }

    deleteTemplateFromGuestlist(row) {
        this.alert.confirm({
            title: `Remove template relation`,
            message: `Are you sure, you want to remove the relation between the guestlist and the template?`,
            confirmBtn: 'Yes, remove relation',
            confirmBtnColor: '#73ccb9'
        }).then(() => {
            return this.api.delete(`guestlists/${row.guestlist.id}/templates/${row.id}`).then(response => {
                this._loadTemplates().then(() => {
                    this.alert.info('Success', 'The relation was removed');
                });
            }, err => this.alert.handle(err));
        }, err => this.alert.handle(err));
    }

    // Private callable functions
    _initWatchers() {
        this.scope.$watch(() => {
            return this.template;
        }, (newVal, oldVal) => {
            if (this.template
                && (
                    !this.templatesStore
                    || _.get(newVal, 'id') !== _.get(oldVal, 'id')
                )
            ) {
                this._prepareTemplatesStore();
            }
        });
    }

    _prepareTemplatesStore() {
        this.templatesStore = this.injector.get('GuestlistTemplates').reset({
            persist: false,
            listview: `Guestlist${this.template.id}Templates`,
            slug: `templates/${this.template.id}/guestlists`,
            visible: [
                'id',
                'guestlist.id',
                'guestlist.name',
                'guestlist.deleted_at',
                'status'
            ]
        });

        this.templatesStore.dispatch('getDefinitions').then(() => {
            this._loadTemplates();
        })
    }

    _loadTemplates() {
        return this.templatesStore.dispatch('getData').then(() => {
            this.rawTemplates = this.templatesStore.state.data;
        });
    }
}

AlTemplateGuestlistsController.$inject = [
    '$injector',
    '$scope'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-template-guestlists/controller.js